@if (leerling$ | async) {
	<div class="dashboard-afwezigheid">
		<app-filter-bar></app-filter-bar>
		<app-filter-panel
			[defaultFilters]="defaultFilters"
			[allFilters]="allFilters()"
			[leerlingselectie]="false"
			(filterExpressionsChange)="filterExpressions.set($event)"
			endpoint="/aanwezigheid"
			[permanentFilterExpressions]="permanentFilters()"
			[overrideDefault]="schooljaarFilterOverride()"
		></app-filter-panel>
		<section class="dashboard">
			<app-aanwezigheid-redenen
				class="no-border"
				[filterExpressions]="filterExpressions()"
				[permanentFilters]="permanentFilters()"
				[attr.data-exportable]="true"
				[leerlingDetails]="true"
			></app-aanwezigheid-redenen>
		</section>
	</div>
}
